import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { createQueryKeyFactory } from "@circle-react/lib/queries/createQueryKeyFactory";
import { queryClient } from "@circle-react/providers/QueryClient/reactQueryConfig";
import type { GamificationSettings } from "@circle-react/types/Gamification";
import { queryOptions } from "react-query";

export const gamificationSettingsKey = createQueryKeyFactory(
  "gamification-settings",
);

const fetchGamificationSettings = () =>
  reactQueryGet<GamificationSettings>(internalApi.gamification.settings());

export const gamificationSettingsQueries = {
  settings: () =>
    queryOptions({
      queryKey: gamificationSettingsKey.root(),
      queryFn: () => fetchGamificationSettings(),
    }),
};

export const gamificationSettingsInvalidations = {
  all: () =>
    queryClient.invalidateQueries({
      queryKey: gamificationSettingsKey.root(),
    }),
};

export const markGamificationResetInProgress = () => {
  queryClient.setQueryData<GamificationSettings>(
    gamificationSettingsKey.root(),
    previous =>
      previous
        ? {
            ...previous,
            points_reset_status: "processing",
            points_reset_action: "reset",
          }
        : previous,
  );
};

export const markGamificationUndoInProgress = () => {
  queryClient.setQueryData<GamificationSettings>(
    gamificationSettingsKey.root(),
    previous =>
      previous
        ? {
            ...previous,
            point_calculation_start_at: null,
            points_reset_action: "undo",
            points_reset_status: "processing",
            reset_by_name: null,
          }
        : previous,
  );
};
